import { defineRule } from 'vee-validate'
import { toBigNumber } from '@injectivelabs/utils'
import { getEthereumAddress } from '@injectivelabs/sdk-ts/utils'

export const errorMessages = {
  required: () => 'This field is required',
  duplicateAddress: () => 'There are duplicate addresses',
  invalidNumber: () => 'This field is not a valid number',
  positiveNumber: () => 'This field should have positive number',
  addressIsWhitelisted: () => 'There is whitelisted injective address',
  injAddress: () => 'There is invalid injective address or excessive whitespace'
} as Record<string, any>

export const defineGlobalRules = () => {
  defineRule(
    'required',
    (value: string | number, _, { field }: { field: string }) => {
      if (!value || !value.toString().length || Number(value) === 0) {
        if (field.includes('date')) {
          return 'dates are required'
        }

        return errorMessages.required()
      }

      return true
    }
  )

  defineRule('min', (value: string, [min]: [number | string]) => {
    const valueInNumber = Number.isNaN(value) && value ? value.length : value
    const valueInBigNumber = toBigNumber(valueInNumber)

    if (valueInBigNumber.lt(min)) {
      return `Value cannot be smaller than ${min}`
    }

    return true
  })

  defineRule('max', (value: string, [max]: [number | string]) => {
    const valueInNumber = Number.isNaN(value) && value ? value.length : value
    const valueInBigNumber = toBigNumber(valueInNumber)

    if (valueInBigNumber.gt(max)) {
      return `Value cannot be greater than ${max}`
    }

    return true
  })

  defineRule('number', (value: string) => {
    if (new RegExp(/^-?(0|[1-9]\d*)?(\.\d+)?$/).test(value)) {
      return true
    }

    return errorMessages.invalidNumber()
  })

  defineRule('positiveNumber', (value: string) => {
    if (
      parseInt(value) > 0 &&
      new RegExp(/^-?(0|[1-9]\d*)?(\.\d+)?$/).test(value)
    ) {
      return true
    }

    return errorMessages.positiveNumber()
  })

  defineRule('isInjectiveAddress', (value: string) => {
    const validateSingleAddress = (address: string) => {
      try {
        getEthereumAddress(address)
      } catch {
        return errorMessages.injAddress()
      }

      return true
    }

    if (value.includes(',')) {
      const addressList = value.split(',')

      const hasDuplicates = addressList.some(
        (address, index) => addressList.indexOf(address) !== index
      )

      if (hasDuplicates) {
        return errorMessages.duplicateAddress()
      }

      for (const address of addressList) {
        const result = validateSingleAddress(address)

        if (result !== true) {
          return result
        }
      }

      return true
    }

    return validateSingleAddress(value)
  })
}

export default defineNuxtPlugin(() => {
  defineGlobalRules()
})
